export default __webpack_public_path__ + "static/media/eventSlide3.861ee5ed.png";